import image from '../../assets/img/General/logo.svg';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to='/' className={`header__logo logo`}>
      <img src={image} alt='logo' />
    </Link>
  );
};
export default Logo;
